import { useQuery } from "@tanstack/react-query";
import { axios } from "@moonscape/shared";

export interface AccountMe {
  id: number;
  email: string;
  userid: string;
  displayName: string | null;
  firstName: string | null;
  lastName: string | null;
  is_admin: boolean;
}

export function useAccountMe() {
  return useQuery({
    queryKey: ["account", "me"],
    queryFn: () =>
      axios.get<AccountMe>("/account/me").then((r) => r.data),
    staleTime: 5 * 60 * 1000, // 5 min — user profile rarely changes
  });
}
